import { useEffect, useMemo } from "react";
import { columns } from "./columns";
import { useTable } from "features/common/components/Table/useTable";

import { TableColumn } from "features/common/components/Table/Table.types";
import { Box, IconButton } from "@mui/material";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import { useFileTsContext } from "features/app/components/hooks/useInfoAppContext";

export const useImportsTable = () => {
  const { fileTsIsFetching, fileTsList, refetchFileTs } = useFileTsContext();

  const buttonColumn: TableColumn = useMemo(() => {
    return {
      id: "test",
      label: "",
      disableSort: true,
      Header: () => (
        <Box
          sx={{
            width: "24px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton
            data-testid="fetch-ts"
            sx={{ padding: 0 }}
            onClick={refetchFileTs}
          >
            <CachedOutlinedIcon fontSize="medium" />
          </IconButton>
        </Box>
      ),
    };
  }, [refetchFileTs]);

  const extendedColumns = [...columns, buttonColumn];

  const table = useTable({ columns: extendedColumns });

  const { setRows } = table;

  useEffect(() => {
    setRows(fileTsList);
  }, [fileTsList, setRows]);

  return { table, fileTsIsFetching, refetchFileTs, fileTsList };
};
